/**
 * @constant
 */
const NameSpaces = {
    LOGIN: "login",
    TRANSLATION: "translation",
    COMMON: "common",
    SW: "sw",
    SETTINGS: "settings",
    NOTIFICATIONS: "notifications",
    BREEDING: "breeding",
    DEVICES: "devices",
    LOGS: "logs",
    LAMBDAS: "lambdas",
    DICTIONARY: "dictionary"

};


module.exports = {
    NameSpaces
};
